import React from 'react';
import { OctagonAlert, SignalHigh, SignalLow, SignalMedium } from 'lucide-react';
import { cn, resolveStatus } from '../ui';

const ICONS = { low: SignalLow, medium: SignalMedium, high: SignalHigh, critical: OctagonAlert };

const TONE_INK = {
  neutral: 'tw-text-content-subtle',
  info: 'tw-text-info',
  warning: 'tw-text-warning',
  danger: 'tw-text-danger',
};

/**
 * A ticket's priority as an icon and a word — deliberately NOT a pill. The
 * status beside it already is one, and two pills of similar tones in one row
 * read as a single coloured smear. The word carries the meaning; the icon and
 * its tone are a second cue, never the only one.
 */
const TicketPriority = ({ priority, className }) => {
  const { label, tone } = resolveStatus(priority || 'medium', 'ticketPriority');
  const Icon = ICONS[priority] || SignalMedium;
  return (
    <span className={cn('tw-inline-flex tw-items-center tw-gap-1.5 tw-whitespace-nowrap tw-text-[0.8125rem] tw-text-content', className)}>
      <Icon size={15} aria-hidden="true" className={cn('tw-shrink-0', TONE_INK[tone])} />
      {label}
    </span>
  );
};

export default TicketPriority;
